(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.google-reviews').forEach((section) => {
    const track = section.querySelector('[data-reviews-track]');
    const previous = section.querySelector('[data-reviews-previous]');
    const next = section.querySelector('[data-reviews-next]');
    if (!track || !previous || !next) return;
    const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.onAwardMegaOutsideClick = this.onAwardMegaOutsideClick.bind(this);
      this.onAwardMegaEscape = this.onAwardMegaEscape.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      document.addEventListener('click', this.onAwardMegaOutsideClick);
      document.addEventListener('keydown', this.onAwardMegaEscape);

      this.bindAwardMegaMenu();
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('click', this.onAwardMegaOutsideClick);
      document.removeEventListener('keydown', this.onAwardMegaEscape);
      this.awardMegaMenuItems?.forEach((details) => {
        details.removeEventListener('toggle', details.awardMegaToggleHandler);
      });
    }

    bindAwardMegaMenu() {
      this.awardMegaMenuItems = this.querySelectorAll('.award-mega');

      this.awardMegaMenuItems.forEach((details) => {
        details.awardMegaToggleHandler = () => {
          if (!details.open) return;

          this.awardMegaMenuItems.forEach((otherDetails) => {
            if (otherDetails !== details) {
              otherDetails.removeAttribute('open');
            }
          });
        };

        details.addEventListener('toggle', details.awardMegaToggleHandler);
      });
    }

    closeAwardMegaMenus() {
      this.awardMegaMenuItems?.forEach((details) => {
        details.removeAttribute('open');
      });
    }

    onAwardMegaOutsideClick(event) {
      if (!this.awardMegaMenuItems?.length) return;

      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('.award-mega')) return;

      this.closeAwardMegaMenus();
    }

    onAwardMegaEscape(event) {
      if (event.key !== 'Escape') return;

      this.closeAwardMegaMenus();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moving-media-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moving-media-strip')) {
    class MovingMediaStrip extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.moving-media-strip__track');
        this.sourceGroup = this.querySelector('.moving-media-strip__group');

        if (!this.track || !this.sourceGroup || this.sourceGroup.children.length === 0) return;

        this.update = this.update.bind(this);
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      update() {
        this.track.querySelectorAll('[data-moving-media-clone]').forEach((clone) => clone.remove());

        const groupWidth = this.sourceGroup.getBoundingClientRect().width;
        if (groupWidth <= 0) return;

        const numberOfGroups = Math.ceil(this.clientWidth / groupWidth) + 1;

        for (let index = 1; index < numberOfGroups; index += 1) {
          const clone = this.sourceGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-moving-media-clone', '');
          clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          clone
            .querySelectorAll('[data-shopify-editor-block]')
            .forEach((element) => element.removeAttribute('data-shopify-editor-block'));
          this.track.appendChild(clone);
        }

        this.style.setProperty('--moving-media-distance', `${groupWidth}px`);
      }
    }

    customElements.define('moving-media-strip', MovingMediaStrip);
  }

  } catch(e) { console.error(e); }
})();
})();
